import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import point from '../../images/point.png';
import './cityDropDown.css';

class CityDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCity: 'toronto',
    };
  }

  componentDidMount() {
    if (this.props.operatingCity) {
      this.changeCity(this.props.operatingCity);
    }
  }

  changeCity = city => {
    this.setState({ currentCity: city });
    this.props.closeDrawer();
  };

  hideCity = city => (this.state.currentCity === city ? { display: 'none' } : {});

  render() {
    const { operatingCity } = this.props;
    return (
      <li className="dropdown hide">
        <Link to="/" className="city-link dropdown-toggle" data-toggle="dropdown">
          {this.state.currentCity}
          <img className="map-point" src={point} alt="pointer" />
        </Link>
        <ul className="drower dropdown-menu">
          <li style={this.hideCity('toronto')}>
            <Link onClick={() => this.changeCity('toronto')} to={operatingCity === 'toronto' ? '/dashboard' : '/'}>
              Toronto
            </Link>
          </li>
          <li style={this.hideCity('Los Angeles')}>
            <Link onClick={() => this.changeCity('Los Angeles')} to="/comingsoon">
              Los Angeles
            </Link>
          </li>
          <li style={this.hideCity('San Francisco')}>
            <Link onClick={() => this.changeCity('San Francisco')} to="/comingsoon">
              San Francisco
            </Link>
          </li>
        </ul>
      </li>
    );
  }
}

export default CityDropdown;



// WEBPACK FOOTER //
// ./src/components/Layout/CityDropdown.js